/**
 * consentService — GDPR consent SCD (Slowly Changing Dimension) audit trail
 *
 * Every consent change is logged as an APPEND-ONLY record:
 *   { user_id, consent_given (boolean), timestamp }
 *
 * NEVER overwrites previous records. Full history maintained for EU GDPR audit.
 *
 * API endpoints (stub — dev team wires to real Azure backend):
 *   POST /api/consent/log     — log a consent change
 *   GET  /api/consent/history  — get consent history for a user
 *   GET  /api/consent/current  — get current consent status
 */

import { apiGet, apiPost } from './apiClient';

/**
 * Log a consent change (opt-in or opt-out)
 * @param {Object} params
 * @param {boolean} params.consent_given - true = opted in, false = opted out
 * @param {string}  params.timestamp     - ISO 8601 timestamp
 * @param {string}  [params.source]      - Where the change was made: 'banner', 'profile', 'first_login'
 * @returns {Promise<Object>} The logged consent record
 */
export async function logConsentChange({ consent_given, timestamp, source = 'banner' }) {
  // TODO: Replace with real API call
  // return apiClient.post('/api/consent/log', { consent_given, timestamp, source });

  const record = {
    id: `consent-${Date.now()}`,
    consent_given,
    timestamp: timestamp || new Date().toISOString(),
    source,
  };
  console.log('[consentService] Consent change logged (stub):', record);
  return record;
}

/**
 * Get full consent history for current user (SCD — all records)
 * @returns {Promise<Array>} Array of consent records, newest first
 */
export async function getConsentHistory() {
  // TODO: Replace with real API call
  // return apiClient.get('/api/consent/history');

  console.log('[consentService] Fetching consent history (stub)');
  return [
    {
      id: 'consent-stub-1',
      consent_given: true,
      timestamp: '2025-01-15T10:30:00Z',
      source: 'first_login',
    },
  ];
}

/**
 * Get current consent status
 * @returns {Promise<Object>} { consent_given: boolean, last_updated: string }
 */
export async function getCurrentConsent() {
  // TODO: Replace with real API call
  // return apiClient.get('/api/consent/current');

  console.log('[consentService] Fetching current consent (stub)');
  return {
    consent_given: true,
    last_updated: '2025-01-15T10:30:00Z',
  };
}
